import { useTranslation } from 'react-i18next';

export default function WhyUs() {
  const { t } = useTranslation();

  const reasons = [
    { icon: 'ri-links-line', title: t('whyUs.r1.title'), desc: t('whyUs.r1.desc') },
    { icon: 'ri-map-2-line', title: t('whyUs.r2.title'), desc: t('whyUs.r2.desc') },
    { icon: 'ri-translate-2', title: t('whyUs.r3.title'), desc: t('whyUs.r3.desc') },
    { icon: 'ri-file-shield-2-line', title: t('whyUs.r4.title'), desc: t('whyUs.r4.desc') },
    { icon: 'ri-hand-heart-line', title: t('whyUs.r5.title'), desc: t('whyUs.r5.desc') },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-4 block">{t('whyUs.badge')}</span>
            <h2 className="text-4xl font-bold text-gray-900 mb-5 leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('whyUs.title').split('\n').map((line, i, arr) => (
                <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
              ))}
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {t('whyUs.desc')}
            </p>
            <div className="rounded-2xl overflow-hidden" style={{ height: 280 }}>
              <img
                src="https://public.readdy.ai/ai/img_res/a63336941c704566b5a88f09144a5475.jpg"
                alt="Yerevan city street"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-4">
            {reasons.map((reason) => (
              <div
                key={reason.title}
                className="flex items-start gap-5 p-5 rounded-xl border border-gray-100 hover:border-blue-200 hover:bg-blue-50/30 transition-all duration-200 cursor-default"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-lg flex-shrink-0">
                  <i className={`${reason.icon} text-blue-600 text-lg`}></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-gray-900 mb-1">{reason.title}</h4>
                  <p className="text-sm text-gray-500 leading-relaxed">{reason.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
